// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /protocols/light — minimal protocol info.
 * Matches Go: `models.ProtocolLight { Name, DefaultInterface, ID }`
 */
export class ProtocolLight implements flatbuffers.IUnpackableObject<ProtocolLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ProtocolLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsProtocolLight(bb: flatbuffers.ByteBuffer, obj?: ProtocolLight): ProtocolLight {
    return (obj || new ProtocolLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsProtocolLight(
    bb: flatbuffers.ByteBuffer,
    obj?: ProtocolLight,
  ): ProtocolLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ProtocolLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  defaultInterfaceJson(): string | null;
  defaultInterfaceJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  defaultInterfaceJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startProtocolLight(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addDefaultInterfaceJson(
    builder: flatbuffers.Builder,
    defaultInterfaceJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, defaultInterfaceJsonOffset, 0);
  }

  static endProtocolLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  static createProtocolLight(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    defaultInterfaceJsonOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ProtocolLight.startProtocolLight(builder);
    ProtocolLight.addId(builder, idOffset);
    ProtocolLight.addName(builder, nameOffset);
    ProtocolLight.addDefaultInterfaceJson(builder, defaultInterfaceJsonOffset);
    return ProtocolLight.endProtocolLight(builder);
  }

  unpack(): ProtocolLightT {
    return new ProtocolLightT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.defaultInterfaceJson(),
    );
  }

  unpackTo(_o: ProtocolLightT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.defaultInterfaceJson = this.defaultInterfaceJson();
  }

  unpackFields(...fields: string[]): ProtocolLightT {
    const t = new ProtocolLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("default_interface_json")) {
      t.defaultInterfaceJson = this.defaultInterfaceJson();
    }
    return t;
  }
}

export class ProtocolLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public defaultInterfaceJson: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const defaultInterfaceJson =
      this.defaultInterfaceJson !== null ? builder.createString(this.defaultInterfaceJson!) : 0;

    return ProtocolLight.createProtocolLight(builder, id, name, defaultInterfaceJson);
  }

  clone(): ProtocolLightT {
    const obj = new ProtocolLightT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.defaultInterfaceJson = this.defaultInterfaceJson;
    return obj;
  }

  equals(other: ProtocolLightT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.defaultInterfaceJson !== other.defaultInterfaceJson) return false;
    return true;
  }
}

export function verifyProtocolLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
